import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { blogData } from '../data/blogData'; 
import AOS from 'aos';
import 'aos/dist/aos.css';

function Blog() {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 9;

  // --- AOS VE SAYFA BAŞLIĞI AYARI ---
  useEffect(() => {
    // Sekme ismini kesin olarak güncelle
    document.title = "Blog & Teknik Bilgiler  | Ankara Merkez Teknik";

    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
    });
  }, []);

  // Sayfalama Matematiği
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogData.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(blogData.length / postsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
  };

  // --- GOOGLE İÇİN BLOG LİSTESİ ŞEMASI (JSON-LD) ---
  const blogListSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "Ankara Merkez Teknik Bilgi Bankası",
    "description": "Ankara kombi, beyaz eşya ve klima servis hizmetlerimiz hakkında güncel arıza çözümleri.",
    "publisher": {
      "@type": "Organization",
      "name": "Ankara Merkez Teknik"
    },
    "blogPost": currentPosts.map(post => ({
      "@type": "BlogPosting",
      "headline": post.baslik,
      "url": `https://ankaramerkezteknik.com.tr/blog/${post.slug}`,
      "datePublished": post.tarih
    }))
  };

  return (
    <div className="blog-list-wrapper">
      <Helmet>
        <title>Teknik Bilgi Bankası & Blog | Ankara Merkez Teknik</title>
        <meta name="description" content="Ankara kombi, beyaz eşya ve klima servis hizmetlerimiz hakkında güncel arıza çözümleri ve teknik bilgiler." />
        <script type="application/ld+json">
          {JSON.stringify(blogListSchema)}
        </script>
      </Helmet>

      {/* --- ÜST BAŞLIK ALANI --- */}
      <section className="blog-simple-section">
        <div className="container">
          <div className="blog-simple-header" data-aos="fade-down">
            <span className="saas-subtitle">Blog Rehberi</span>
            <h1>Teknik Bilgi Bankası</h1>
            <p>
              Ankara Merkez Teknik olarak; kombi, beyaz eşya ve klima arızaları, 
              enerji tasarrufu yöntemleri ve servis süreçlerimiz hakkında detaylı makaleler.
            </p>
          </div>
        </div>
      </section>

      {/* --- BLOG KARTLARI VE SAYFALAMA --- */}
      <section className="pure-blog-content">
        <div className="container">
          
          <div className="blog-text-grid">
            {currentPosts.map((post, index) => (
              <div 
                className="blog-text-card" 
                key={post.id}
                data-aos="fade-up"
                data-aos-delay={index * 100} // Kartlar sırayla süzülerek gelsin
              >
                <span className="b-date">{post.tarih}</span>
                <h2><Link to={`/blog/${post.slug}`}>{post.baslik}</Link></h2>
                <p>{post.ozet}</p>
                <Link to={`/blog/${post.slug}`} className="b-read-more">Devamını Oku →</Link>
              </div>
            ))}
          </div>

          {/* Sayfalama (Pagination) */}
          <div className="pure-pagination" data-aos="fade-in">
            {Array.from({ length: totalPages }, (_, i) => (
              <button 
                key={i + 1} 
                onClick={() => paginate(i + 1)}
                className={currentPage === i + 1 ? 'active-page' : ''}
              >
                {i + 1}
              </button>
            ))}
          </div>

        </div>
      </section>
    </div>
  );
}

export default Blog;